import React, { FC, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getJobList } from "../../../../../../Actions/API/Job/JobActions"
import { useJobList } from "../../../../../../Hooks/useJobList"
import { useAppState } from "../../../../../../Hooks/useReduxState"
import { getEmptyStalePageOrStalePagesContaining } from "../../../../../../Models/Client/RemoteData"
import { jobColumns } from "./JobColumns"
import { JobsList, JobsListProps } from "./JobsList"

export const JobsListProvider: FC<
    Omit<JobsListProps, "onVisibleItemsChanged">
> = ({ appID, params, ...restParams }) => {
    const jobListFetch = useJobList(appID, { params, refetchOnStale: false })
    const dispatch = useDispatch()
    const [visibleItems, setVisibleItems] = useState<string[]>([])
    const pagesToFetch = useAppState(
        state =>
            getEmptyStalePageOrStalePagesContaining(
                state.api.jobs.table[appID],
                visibleItems
            ),
        (array1: number[], array2: number[]) =>
            array1.length === array2.length &&
            array1.every((value, index) => value === array2[index])
    )

    useEffect(() => {
        pagesToFetch.forEach(page => dispatch(getJobList(appID, params, page)))
    }, [appID, dispatch, pagesToFetch, params])

    return (
        <JobsList
            appID={appID}
            params={params}
            jobListFetch={jobListFetch}
            {...restParams}
            columns={jobColumns}
            onVisibleItemsChanged={setVisibleItems}
        />
    )
}
